import React from 'react';
import { IconFileArrowRight } from '@tabler/icons-react';

const ActionBarRiskHeatmapComp = (props) => {
  return (
    <>
      <div className="d-flex align-items-center py-1">
        {/*begin::Button*/}
        <div className="me-4">
          {props.listRiskHeatmap.length > 0 ? (
            <button
              onClick={() => props.handleExport()}
              className="btn btn-sm btn-outline-success"
            >
              <IconFileArrowRight stroke={2} /> Export to Excel
            </button>
          ) : (
            ''
          )}
        </div>
        {/*end::Button*/}
      </div>
    </>
  );
};

export default ActionBarRiskHeatmapComp;
